<template>
  <div class="effect-analysis-x">
    <div class="top-box box-shadow">
      <div class="nav-box">
        <i class="iconfont iconicon_fanhui" style="color: #999; margin-right: 4px"></i>
        <span class="go-back" @click="goBack">返回列表</span>
        <span class="division"></span>
        <span class="title">营销效果分析</span>
        <div class="tip-box">
          <i class="el-icon-warning warning-icon"></i>
          <el-popover
            placement="bottom-start"
            title=""
            width="380"
            trigger="hover"
            content="营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供，无法查看到会员明细数据"
          >
            <span style="color: #333" slot="reference"
              >营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供，无法查看到会员明细数据</span
            >
          </el-popover>
        </div>
      </div>
      <div class="info-box">
        <div class="roi-box-wrap">
          <div class="roi-box">
            <div class="roi">ROI</div>
            <div class="roi-data">
              <div>
                <span>ROI（投入产出比）</span>
                <el-tooltip class="item" effect="light" :content="roiTip" placement="top">
                  <span class="question_icon">?</span>
                </el-tooltip>
                <span class="update-btn" @click="updateROI">修改</span>
              </div>
              <div class="value">{{ roi }}</div>
            </div>
            <div class="roi-update"></div>
          </div>
        </div>

        <div class="task-content">
          <div>任务名称：{{ effectData.activityTitle }}</div>
          <div>
            状态： <span class="send-status">已发送</span> 会员总数：<span class="send-status num">{{ effectData.sendNum }}人</span
            >
            营销成本：<span class="num">{{ effectData.marketingCosts }}元</span
            >
          </div>
          <div v-if="officialObj.source =='DONGDONG_MARKETING_BATCH'">
            <div v-if="this.officialObj.smsType == 1">消息内容：<span class="rich_title" @click="showMediaInfo">{{ effectData.mediaTitle }}</span></div>
            <div v-else>消息内容：{{ effectData.content }}</div>
          </div>
          <div v-else>
            <div v-if="this.officialObj.smsType == 1">短信内容：<span class="rich_title" @click="showMediaInfo">{{ effectData.mediaTitle }}</span></div>
            <div v-else>短信内容：{{ effectData.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="effect-data box-shadow">
      <div class="search-box">
        <span>统计时间：</span>
        <el-select v-model="formData.type" placeholder="请选择" style="width: 140px; margin-right: 12px; vertical-align: top" @change="switchType">
          <el-option v-for="item in timeType" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div class="my_select_time">
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.startTime"
            type="date"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 120px; font-size: 12px"
            class="time1"
            :clearable="false"
            @change="handleChange"
          ></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker
            prefix-icon="no_icon"
            v-model="formData.endTime"
            type="date"
            :placeholder="'选择日期时间'"
            size="small"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 145px; font-size: 12px"
            class="time2"
            @change="handleChange"
            :clearable="false"
          ></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTime()"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
        <template v-if="isAutoMarketingOfficial">
          <div class="isAutoMarketingOfficial2"></div>
          <span class="isAutoMarketingOfficial3">发送批次：</span>
          <el-tooltip :content="getSealName" :disabled="batchValue == ''" placement="bottom">
            <el-select
              key="batchValue"
              v-model="batchValue"
              style="width: 208px;"
              placeholder="请选择">
              <el-option
                label="全部"
                value="">
              </el-option>
              <el-option
                v-for="item in batchList"
                :key="item.id"
                :label="item.preActivityName + ' ' + item.sendTime"
                :value="item.id">
              </el-option>
            </el-select>
          </el-tooltip>
        </template>
        <el-button type="plain" :style="{ color: globalBG, 'border-color': globalBG }" style="margin-left: 20px" @click="handleSearch">
          <i
            class="el-icon-search"
            style="
              display: inline-block;
              width: 14px;
              height: 12px;
              margin-top: -10px;
            "
          ></i>
          查询</el-button
        >
        <el-button @click="reset">重置</el-button>
        <el-radio v-model="radioD" label="1" style="float: right;margin-right: 30px;" v-if="this.cycleList.length">
          统计数据
          <el-select v-model="officialObj.outerId" @change="getEffectData">
            <el-option  v-for="item in cycleList" :key="item.id" :value="item.id" :label="item.batchName"></el-option>
          </el-select>
        </el-radio>
        <div style="margin-top: 10px;">
          <el-button style="float: right; margin-right: 30px" @click="exportData">导出数据</el-button>
        </div>
      </div>
      <div class="tab-line">
        <div class="tab-item" :class="{ active: switchIndex == '0' }" @click="switchTab('0')">
          汇总
        </div>
        <div class="tab-item" :class="{ active: switchIndex == '1' }" @click="switchTab('1')">
          触达
        </div>
        <div class="tab-item" :class="{ active: switchIndex == '2' }" @click="switchTab('2')">
          点击
        </div>
      </div>

      <div class="effect-content">
        <div
          class="effect-item"
          v-for="(item, index) in effectList"
          :key="index"
          :style="{ width: item.title == '会员购买分析' ? '270px' : '250px' }"
        >
          <div class="title">{{ item.title }}</div>
          <div class="content">
            <p v-for="(eItem, eIndex) in item.dataList" :key="eIndex">
              {{ eItem.name }} {{ eItem.value ? eItem.value : "--" }}
              {{ eItem.unit }}
            </p>
          </div>
        </div>
      </div>

      <div class="trend-analysis">
        <div class="title-line"><span>趋势分析</span></div>
        <div class="trend-wrap">
          <div class="trend-box-x">
            <div class="trend-item" v-for="(item, index) in trendingListX" :key="index">
              <div class="type-title">{{ item.title }}</div>
              <div class="trend-radio">
                <template v-for="(trendItem, trendIndex) in item.data">
                  <el-radio
                    :style="{ width: index != '3' ? '170px' : '240px', 'margin-right': '0' }"
                    @change="getTrendValue(trendItem)"
                    :key="trendIndex"
                    v-model="trendKey"
                    :label="trendItem.key"
                  >
                    <span style="color: #666">{{ trendItem.name }}</span>
                  </el-radio>
                </template>
              </div>
            </div>
          </div>
          <div class="trend-box">
                        <div class="echart-box">
              <echarts :legendShow="false" :key="trendKey" :seriesData="seriesData" :echartsDate="echartsDate"></echarts>
            </div>
          </div>
        </div>
      </div>
      <div class="good-analysis">
        <div class="title-line" style="margin-top: 20px;"><span>TOP100商品分析</span></div>
        <div style="margin: 16px 0;">
          <span>排序规则：</span>
          <el-select
            key="collationValue"
            v-model="collationValue"
            style="width: 208px;"
            @change="selectChange"
            placeholder="请选择">
            <el-option
              v-for="item in collationList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="tip-box">
          <i class="el-icon-warning warning-icon"></i>
          <el-popover
            v-if="isAutoMarketingOfficial"
            placement="bottom-start"
            title=""
            width="380"
            trigger="hover"
            content="如发送批次为【全部】，则汇总展示每个批次的商品明细展示，列表中 “/” 代表无法获取该数据，数据未进入浏览、加购、付款商品的TOP100"
          >
            <span style="color: #333" slot="reference"
              >如发送批次为【全部】，则汇总展示每个批次的商品明细展示，列表中 “/” 代表无法获取该数据，数据未进入浏览、加购、付款商品的TOP100</span
            >
          </el-popover>
          <el-popover
            v-else
            placement="bottom-start"
            title=""
            width="380"
            trigger="hover"
            content="列表中 “/” 代表无法获取该数据，数据未进入浏览、加购、付款商品的TOP100"
          >
            <span style="color: #333" slot="reference"
              >列表中 “/” 代表无法获取该数据，数据未进入浏览、加购、付款商品的TOP100</span
            >
          </el-popover>
        </div>
        <div class="goods-item" style="margin-top: 16px">
          <el-table
            ref="goodsTable"
            :data="topGoods"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            tooltip-effect="light"
            style="width: 100%; border: 1px solid #eee"
            stripe
            v-loading="tableLoading"
            max-height="650"
          >
            <el-table-column label="序号" width="80px">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="商品信息" width="240px">
              <template slot-scope="scope">
                <div class="goods-box">
                  <img :src="scope.row.picUrl" alt="" />
                  <div>
                    <el-tooltip class="item" effect="dark" :content="scope.row.skuName" placement="right">
                      <p class="shop-title">
                        {{ scope.row.skuName }}
                      </p>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="'skuid:' + scope.row.skuId" placement="right">
                      <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="browsePv" min-width="90px" label="浏览PV(次数)">
              <template slot-scope="scope">
                <span>{{ scope.row.browsePv > 0 ? scope.row.browsePv : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="browseUv" min-width="90px" label="浏览UV(人数)">
              <template slot-scope="scope">
                <span>{{ scope.row.browseUv > 0 ? scope.row.browseUv : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="cartUserNum" label="加购人数">
              <template slot-scope="scope">
                <span>{{ scope.row.cartUserNum > 0 ? scope.row.cartUserNum : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="cartSkuNum" label="加购件数">
              <template slot-scope="scope">
                <span>{{ scope.row.cartSkuNum > 0 ? scope.row.cartSkuNum : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="payUserNum" label="付款人数">
              <template slot-scope="scope">
                <span>{{ scope.row.payUserNum > 0 ? scope.row.payUserNum : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="paySkuNum" label="付款件数">
              <template slot-scope="scope">
                <span>{{ scope.row.paySkuNum > 0 ? scope.row.paySkuNum : '/' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="payAmount" label="付款金额">
              <template slot-scope="scope">
                <span>{{ scope.row.payAmount > 0 ? scope.row.payAmount : '/' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- <div class="goods-item">
          <div class="goods-title">浏览商品TOP10</div>
          <el-table
            ref="goodsTable"
            sum-text="合计"
            show-summary
            :data="browseGoods"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            tooltip-effect="light"
            style="width: 100%; border: 1px solid #eee"
            stripe
            v-loading="tableLoading"
          >
            <el-table-column label="序号" width="50px">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="商品">
              <template slot-scope="scope">
                <div class="goods-box">
                  <img :src="scope.row.picUrl" alt="" />
                  <div>
                    <el-tooltip class="item" effect="dark" :content="scope.row.wareName" placement="right">
                      <p class="shop-title">
                        {{ scope.row.wareName }}
                      </p>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="'skuid:' + scope.row.skuId" placement="right">
                      <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="80" prop="pv" sortable label="PV(次数)"></el-table-column>
            <el-table-column width="80" prop="uv" sortable label="UV(人)"></el-table-column>
          </el-table>
        </div>
        <div class="goods-item">
          <div class="goods-title">加购商品TOP10</div>
          <el-table
            ref="goodsTable"
            sum-text="合计"
            show-summary
            :data="cartGoods"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            tooltip-effect="light"
            style="width: 100%; border: 1px solid #eee"
            stripe
            v-loading="tableLoading"
          >
            <el-table-column label="序号" width="50px">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="商品">
              <template slot-scope="scope">
                <div class="goods-box">
                  <img :src="scope.row.picUrl" alt="" />
                  <div>
                    <el-tooltip class="item" effect="dark" :content="scope.row.wareName" placement="right">
                      <p class="shop-title">
                        {{ scope.row.wareName }}
                      </p>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="'skuid:' + scope.row.skuId" placement="right">
                      <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="80px" prop="userNum" sortable label="加购人数"></el-table-column>
            <el-table-column width="80px" prop="skuNum" sortable label="加购件数"></el-table-column>
          </el-table>
        </div>
        <div class="goods-item" style="width: 590px">
          <div class="goods-title">付款商品TOP10</div>
          <el-table
            ref="goodsTable"
            sum-text="合计"
            show-summary
            :data="payGoods"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            tooltip-effect="light"
            style="width: 100%; border: 1px solid #eee"
            stripe
            v-loading="tableLoading"
          >
            <el-table-column label="序号" width="50px">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="商品">
              <template slot-scope="scope">
                <div class="goods-box">
                  <img :src="scope.row.picUrl" alt="" />
                  <div>
                    <el-tooltip class="item" effect="dark" :content="scope.row.wareName" placement="right">
                      <p class="shop-title">
                        {{ scope.row.wareName }}
                      </p>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="'skuid:' + scope.row.skuId" placement="right">
                      <p class="sku-line">skuid: {{ scope.row.skuId }}</p>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="110" prop="userNum" sortable label="付款人数"></el-table-column>
            <el-table-column width="100" prop="skuNum" sortable label="付款件数"></el-table-column>
            <el-table-column width="100" prop="amount" sortable label="付款金额"></el-table-column>
          </el-table>
        </div> -->
      </div>
    </div>

    <!--修改单价弹窗-->
    <el-dialog title="修改单价" :visible.sync="updateState" width="30%">
      <div>
        <el-input type="number" v-model="unitPrice" clearable style="width: 90%"></el-input>
        <span style="width: 10%">元/条</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateState = false">取 消</el-button>
        <el-button type="primary" @click="updateROI">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 富信模板 -->
    <sms-info 
      v-if="smsInfoShow" 
      @close="smsInfoShow = false" 
      :isShow="smsInfoShow" 
      :id="smsInfoId"
      :title="smsInfoTitle"
      :text="smsInfoText"
    />

    <!-- 生成报表 -->
    <generate :control = 'control'
              v-if="control"
               @transData="(val) => (control = val)"
               @transData1 = 'getphone1'         
               ></generate>


  </div>
</template>

<script>
import { getOfficialData, getEffectPreAutoTaskList } from "@/api/smsMarketing";
import { mapState } from "vuex";
import echarts from "@/components/echarts.vue";
import { updateUnitPrice,officialExport } from "@/api/sellerController";
import smsInfo from '@/components/sms-info'
import generate from '../components/generate_report.vue'

export default {
  name: "",
  data() {
    return {
      radioD: "1",
      control:false,
      smsInfoShow: false, // 富信
      smsInfoId: "", // 富信id
      smsInfoTitle: "", // 富信标题
      smsInfoText: "", // 富信内容
      formData: {
        startTime: "",
        endTime: "",
        type: "7",
      },
      browseGoods: [], // 浏览商品
      cartGoods: [], // 加购商品
      payGoods: [], // 付款商品
      topGoods: [], // top100
      seriesData: [], // 图标所需的趋势分析数据
      echartsDate: [],
      tableLoading: false,
      timeType: [
        {
          label: "自定义",
          value: "",
        },
        {
          label: "近3天",
          value: "3",
        },
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
      ],
      trendingList: [
        {
          orderStartTime: "2015-02-03",
          totalPin: "78",
          totalPayment: "10",
          totalOrder: "20",
        },
      ], // 趋势分析
      updateState: false,
      unitPrice: "",
      roi: "",
      effectList: [], // 分析数据
      switchIndex: 0,
      effectData: {}, // 效果分析数据
      beanType: 0, // 趋势类型
      flag: "",
      shopMemberType: "",
      trendKey: "",
batchValue: "", // 发送批次-选中
      batchList: [], // 发送批次
      trendingListX: [],
      collationValue: "payUserNum", // 排序规则
      collationList: [
        { label: '按浏览PV（次数）', value: 'browsePv'},
        { label: '按浏览UV（人数）', value: 'browseUv'},
        { label: '按加购人数', value: 'cartUserNum'},
        { label: '按加购件数', value: 'cartSkuNum'},
        { label: '按付款人数', value: 'payUserNum'},
        { label: '按付款件数', value: 'paySkuNum'},
        { label: '按付款金额', value: 'payAmount'},
      ], // 排序选项
    };
  },
  props: {
    officialObj: {
      type: Object,
      default: () => {},
    },
    homeJump: {
      type: Boolean,
      default: false,
    },
    isAutoMarketOfficalModule: {
      type: Boolean,
      default: false,
    },
    cycleList:{
      type: Array,
      default: () => []
    }
  },
  components: {
    echarts,
    smsInfo,
    generate
  },
  watch: {
    shopInfo(newVal) {
      if (newVal) {
        this.shopMemberType = this.shopInfo.shopMemberType;
        this.getEffectData();
      }
    },
  },
  mounted() {
    console.log(this.officialObj,this.$route.query.source,'6666666666666666666666666',this.cycleList);
    this.shopMemberType = this.shopInfo.shopMemberType;
    // this.unitPrice = this.oUnitPrice;

    if (this.officialObj.source == "AUTO_MARKETING") {
      // 自动化营销
      this.formData.type = "";
      // var startTime = this.switchTypeDate(-30);
      // if (new Date(this.officialObj.activityStartTime).getTime() > new Date(startTime).getTime()) {
      //   startTime = this.officialObj.activityStartTime;
      // }
      // 修改为 传过来的时间往后退一个月
      this.formData.startTime = this.switchTypeDate(0);
      this.formData.endTime = this.switchTypeDate(30);
      // this.formData.startTime = startTime;
      // this.formData.endTime = this.switchTypeDate(0);
    } else {
      var day = "7";
      if (this.homeJump) {
        // 首页跳转
        this.formData.type = "";
        day = this.officialObj.sendDay;
      }
      this.switchType(day);
    }
console.log('this.isAutoMarketingOfficial------>', this.isAutoMarketingOfficial)
    if (this.isAutoMarketingOfficial) {
      this.getEffectPreAutoTaskList()
    }
    this.getEffectData();
  },
  methods: {
    // 展示富短信内容
    showMediaInfo() {
      this.smsInfoShow = true
      this.smsInfoId = this.effectData.mediaMulitiFileId
      this.smsInfoTitle = this.effectData.mediaTitle
      this.smsInfoText = this.effectData.content
    },

    // 获取发送批次
    getEffectPreAutoTaskList() {
      getEffectPreAutoTaskList({ activityId: this.officialObj.outerId }).then((res) => {
        this.batchList = res.data || []
        this.getEffectData()
      })
    },

    handleChange() {
      this.formData.type = "";
    },
    getTrendValue(item) {
      // console.log("item", item);
      var key = item.key;
      var tendencyList = this.effectData.tendencyList;
      if (!tendencyList) {
        // 空数据给默认
        this.seriesData = [
          {
            name: item.name,
            data: [0, 0],
          },
        ];
        this.echartsDate = [this.formData.startTime, this.formData.endTime];
        return;
      }
      var dataList = [];
      var echartsDate = [];
      tendencyList.forEach((item) => {
        dataList.push(item[key]);
        echartsDate.push(item.effectDate);
      });
      this.echartsDate = echartsDate;
      this.seriesData = [
        {
          name: item.name,
          data: dataList,
        },
      ];
    },
    // switchBean(index) {
    //   this.beanType = index;
    //   this.getSeriesData();
    // },
    switchTypeDate(val) {
      var dd = this.isAutoMarketOfficalModule?  new Date(this.officialObj.activityStartTime): new Date();
      dd.setDate(dd.getDate() + +val);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      var result = y + "-" + m + "-" + d;
      return result;
    },
    getDiffDate(val) {
      var dd = new Date();
      dd.setDate(dd.getDate() + +val);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      var result = y + "-" + m + "-" + d;
      return result;
    },
    switchType(val) {
      console.log('545454454',this.officialObj.activityStartTime,val);
      if (this.officialObj.source == "AUTO_MARKETING") {
         this.formData.startTime = this.officialObj.activityStartTime
         this.formData.endTime = this.switchTypeDate(val);
         if(val==''){
          this.formData.startTime=''
          this.formData.endTime=''
         }
        // var dd = new Date();
        // dd.setDate(dd.getDate() + -val);
        // var y = dd.getFullYear();
        // var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        // var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        // var result = y + "-" + m + "-" + d;
        // this.formData.startTime = result;
        return
      }
      val--;
      var startTime = "";
      if(this.officialObj.sendTime){
        startTime = this.officialObj.sendTime.substr(0, 10)
      }else{
        var ss = new Date();
        ss.setDate(ss.getDate());
        var ys = ss.getFullYear();
        var ms = ss.getMonth() + 1 < 10 ? "0" + (ss.getMonth() + 1) : ss.getMonth() + 1;
        var ds = ss.getDate() < 10 ? "0" + ss.getDate() : ss.getDate();
        startTime = ys + "-" + ms + "-" + ds;
      }
      // startTime = this.officialObj.sendTime ? this.officialObj.sendTime.substr(0, 10) : new Date();
      this.formData.startTime = startTime;

      var dd = new Date(startTime);
      dd.setDate(dd.getDate() + +val);
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      var endTime = y + "-" + m + "-" + d;
      this.formData.endTime = endTime;
      console.log("formData", this.formData);
    },

    switchTab(index) {
      this.switchIndex = index;
      var flagList = ["", false, true];
      this.flag = flagList[this.switchIndex];
      this.getEffectData();
    },

    getEffectData() {
      var officialObj = this.officialObj;
      var param = {
        flag: this.flag,
        startTime: this.formData.startTime,
        endTime: this.formData.endTime,
                outerId: officialObj.outerId,
        source: officialObj.source,
      };

      if (this.isAutoMarketingOfficial && this.batchValue != "") { // 自动化营销模型专属
        param.outerId = this.batchValue
        param.source = "AUTO_MARKETING_BATCH"
      }

      getOfficialData(param).then((res) => {
        console.log(res);
        if (res.code == "1") {
          var effectData = res.data;
          this.effectData = effectData;
          this.roi = effectData.roi;
          if (this.effectData.smsType == 1) {
            this.unitPrice = res.data.unitPriceDigital ? res.data.unitPriceDigital : "0.42"
          } else if(this.effectData.smsType == 2) {
            this.unitPrice = res.data.unitCardPrice ? res.data.unitCardPrice : "0.38"
          } else {
            this.unitPrice = res.data.unitPrice ? res.data.unitPrice : "0.05"
          }
          // this.browseGoods = JSON.parse(effectData.skuBrowsePvUvTop) || [];
          // this.cartGoods = JSON.parse(effectData.skuCartListTop) || [];
          // this.payGoods = JSON.parse(effectData.skuPayListTop) || [];
          this.topGoods = effectData.skuTopVos || [];
          if(this.$refs.goodsTable) {
            this.$refs.goodsTable.sort('payUserNum','descending');
          }
          this.encapEffect(effectData);
          // this.getSeriesData();
          this.getTendencyList();
        }
      });
    },
    getTendencyList() {
      var tendencyMap = [
        {
          title: "流量趋势",
          data: [
            {
              key: "pv",
              name: "短链接点击PV",
            },
            {
              key: "uv",
              name: "短链接点击UV",
            },
            {
              key: "skuPvNum",
              name: "商品详情页PV",
            },
            {
              key: "skuUvNum",
              name: "商品详情页UV",
            },
            {
              key: "shopPvNum",
              name: "店铺首页PV",
            },
            {
              key: "shopUvNum",
              name: "店铺首页UV",
            },
          ],
        },
        {
          title: "转化趋势",
          data: [
            {
              key: "ordPins",
              name: "下单人数",
            },
            {
              key: "ordAmount",
              name: "下单金额",
            },
            {
              key: "ordNum",
              name: "下单订单数",
            },
            {
              key: "ordQtty",
              name: "下单件数",
            },
            {
              key: "payPins",
              name: "付款人数",
            },
            {
              key: "payAmount",
              name: "付款金额",
            },
            {
              key: "payNum",
              name: "付款订单数",
            },
            {
              key: "payQtty",
              name: "付款件数",
            },
          ],
        },
        {
          title: "兴趣趋势",
          data: [
            {
              key: "followSkuNum",
              name: "关注商品人数",
            },
            {
              key: "followShopNum",
              name: "关注店铺人数",
            },
            {
              key: "cartNum",
              name: "加购人数",
            },
          ],
        },
        {
          title: "会员趋势",
          data: [
            {
              key: "memberBuyPins",
              name: "已购会员购买客户数",
            },
            {
              key: "brandMemberBuyPins",
              name: "品牌开卡会员购买客户数",
            },
            {
              key: "brandMemberNewBuyPins",
              name: "品牌开卡会员购买新客户数",
            },
            {
              key: "cardMemberBuyPins",
              name: "店铺开卡会员购买客户数",
            },
            {
              key: "cardMemberNewBuyPins",
              name: "店铺开卡会员购买新客户数",
            },
          ],
        },
      ];
      var shopMemberType = this.shopMemberType;
      if (shopMemberType == "2" || shopMemberType == "4") {
        // 显示店铺开卡会员
        tendencyMap[3].data.splice(1, 2);
      } else if (shopMemberType == "3" || shopMemberType == "5") {
        // 显示品牌开卡会员
        tendencyMap[3].data.splice(3, 2);
      }
      this.trendingListX = tendencyMap;
      var firstItem = tendencyMap[0].data[0];
      this.trendKey = firstItem.key;
      this.getTrendValue(firstItem);
    },
    // 效果分析数据封装
    encapEffect(data) {
      // 触达分析
      var targetCustomerMap = [
        {
          name: "预计触达人数：",
          value: data.sendSubmitNum,
          unit: "人",
        },
        {
          name: "实际触达人数：",
          value: data.sendNum,
          unit: "人",
        },
        {
          name: "触达率：",
          value: data.rate,
          unit: "%",
        },
      ];

      if (this.officialObj.source == "AUTO_MARKETING") {
        targetCustomerMap = [
          {
            name: "实际触达人数：",
            value: data.sendNum,
            unit: "人",
          },
        ];
      }

      // 流量分析
      var accessResponseMap = [
        {
          name: "短链点击PV：",
          value: data.pv,
          unit: "次",
        },
        {
          name: "短链访点击UV：",
          value: data.uv,
          unit: "人",
        },
        {
          name: "商品详情页PV：",
          value: data.skuPvNum,
          unit: "",
        },
        {
          name: "商品详情页UV：",
          value: data.skuUvNum,
          unit: "",
        },
        {
          name: "店铺首页PV：",
          value: data.shopPvNum,
          unit: "",
        },
        {
          name: "店铺首页UV：",
          value: data.shopUvNum,
          unit: "",
        },
      ];
      // 下单分析
      var takeOrderMap = [
        {
          name: "下单转化率：",
          value: data.orderRate,
          unit: "%",
        },
        {
          name: "下单人数：",
          value: data.ordPins,
          unit: "人",
        },
        {
          name: "下单金额：",
          value: data.ordAmount,
          unit: "元",
        },
        {
          name: "下单订单数：",
          value: data.ordNum,
          unit: "单",
        },
        {
          name: "下单件数：",
          value: data.ordQtty,
          unit: "件",
        },
      ];
      // 付款分析
      var payMap = [
        {
          name: "下单-付款转化率：",
          value: data.orderPayRate,
          unit: "%",
        },
        {
          name: "付款转化率：",
          value: data.payRate,
          unit: "%",
        },
        {
          name: "付款人数：",
          value: data.payPins,
          unit: "人",
        },
        {
          name: "付款金额：",
          value: data.payAmount,
          unit: "元",
        },
        {
          name: "付款订单数：",
          value: data.payNum,
          unit: "单",
        },
        {
          name: "付款件数：",
          value: data.payQtty,
          unit: "件",
        },
        {
          name: "客单价：",
          value: data.perCustomerTransaction,
          unit: "元",
        },
      ];
      // 兴趣分析
      var successMap = [
        {
          name: "关注商品人数：",
          value: data.followSkuNum,
          unit: "人",
        },
        {
          name: "关注店铺人数：",
          value: data.followShopNum,
          unit: "人",
        },
        {
          name: "加购人数：",
          value: data.cartNum,
          unit: "人",
        },
      ];
      // 会员购买分析
      var marketingInsightIntoMap = [
        {
          name: "已购会员购买客户数：",
          value: data.memberBuyPins,
          unit: "人",
        },
        {
          name: "品牌开卡会员购买客户数：",
          value: data.brandMemberBuyPins,
          unit: "人",
        },
        {
          name: "店铺开卡会员购买客户数：",
          value: data.cardMemberBuyPins,
          unit: "人",
        },
        {
          name: "品牌开卡会员购买新客户数：",
          value: data.brandMemberNewBuyPins,
          unit: "人",
        },
        {
          name: "店铺开卡会员购买新用户数：",
          value: data.cardMemberNewBuyPins,
          unit: "人",
        },
      ];
      var shopMemberType = this.shopMemberType;
      console.log("shopMemberType:", shopMemberType);
      if (shopMemberType == "2" || shopMemberType == "4") {
        marketingInsightIntoMap.splice(1, 1);
        marketingInsightIntoMap.splice(2, 1);
      } else if (shopMemberType == "3" || shopMemberType == "5") {
        marketingInsightIntoMap.splice(2, 1);
        marketingInsightIntoMap.splice(3, 1);
      }

      var effectList = [
        {
          title: "触达分析",
          dataList: targetCustomerMap,
        },
        {
          title: "流量分析",
          dataList: accessResponseMap,
        },
        {
          title: "下单分析",
          dataList: takeOrderMap,
        },
        {
          title: "付款分析",
          dataList: payMap,
        },
        {
          title: "兴趣分析",
          dataList: successMap,
        },
        {
          title: "会员购买分析",
          dataList: marketingInsightIntoMap,
        },
      ];
      this.effectList = effectList;
      console.log("effectList:", effectList);
    },

    goBack() {
      sessionStorage.removeItem("selectEffectObj");
      this.$emit("onClose", false);
    },
    clearTime() {},
    handleSearch() {
      this.getEffectData();
    },
    reset() {
      this.formData.type = "7";
      this.switchType("7");
this.batchValue = ""
      this.getEffectData();
    },
    exportData() {
      this.control = true
    },
     getphone1(val){
      var name = '';
      if(this.$route.path.indexOf("/auto_market_official_module") != -1 || this.officialObj.source == "AUTO_MARKETING"){
        name= '自动化营销模型'
      }else if(this.$route.path.indexOf("/member_send") != -1 || this.effectData.activityTitle.indexOf("会员发送")!=-1){
        name= '会员发送'
      }else if(this.$route.path.indexOf("/accurate_market") != -1 || this.officialObj.source =='PRECISION_MARKETING'){
        name= '精准营销'
      }else if(this.$route.path.indexOf("/intelligent_market") != -1 || this.officialObj.source =='INTELLIGENT_MARKETING'){
        name = '智能营销'
      }else if(this.$route.path.indexOf("/pop_presell_order_send") != -1 || this.$route.path.indexOf("/self_presell_order_send") != -1 || this.effectData.activityTitle.indexOf("预售订单发送")!=-1){
        name = '预售订单发送'
      }else if(this.$route.path.indexOf("/order_sent") != -1 || this.effectData.activityTitle.indexOf("订单发送")!=-1){
        name = '订单发送'
      }else if(this.officialObj.source =='DONGDONG_MARKETING_BATCH'){
        name= '专享客服'
      }
      var param = {
        outerId: this.officialObj.outerId,
        source: this.officialObj.source,
                exportType:name,
        exportRemark:val,
        startTime: this.formData.startTime,
        endTime: this.formData.endTime
      };

      if (this.isAutoMarketingOfficial && this.batchValue != "") { // 自动化营销模型专属
        param.outerId = this.batchValue
        param.source = "AUTO_MARKETING_BATCH"
      }

      var paramStr = "";
      for (var key in param) {
        var temp = "&" + key + "=" + param[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      officialExport(paramStr).then((res)=>{
         if(res.code == 1){
          this.control = true
          this.$message.success(res.message)
         }else{
          this.$message.error(res.data.message)
         }
      })
    },
    updateROI() {
      if (this.updateState) {
        updateUnitPrice( this.effectData.smsType == 1 ? 1 : this.effectData.smsType == 2 ? 2: 0, this.unitPrice ).then((res) => {
          if (res.code == "1") {
            this.$message.success("修改成功！");
            this.getEffectData();
          } else {
            this.$message.error(res.message);
          }
        });
      }
      this.updateState = !this.updateState;
    },
    // 列表排序
    selectChange(value) {
      this.$refs.goodsTable.sort(value,'descending');
    },
  },
  computed: {
    ...mapState({
      roiTip: "roiTip",
      globalBG: "globalBG",
    }),
    // oUnitPrice(nVal, oVal) {
    //   return this.$store.getters.loginUserInfo.unitPrice;
    // },
    shopInfo() {
      return this.$store.getters.shopInfo;
    },
isAutoMarketingOfficial() {
      return this.$route.path == '/marketing/auto_marketing_official/auto_market_official_module' ? true : false
    },
    getSealName(){
      for(let e of this.batchList){
        if(e.id == this.batchValue){
          return e.preActivityName + ' ' + e.sendTime
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
.effect-analysis-x {
  padding: 11px 20px;

  .rich_title {
    color: #7f85e9;
    font-size: 14px;
    cursor: pointer;
  }
  .top-box {
    margin-bottom: 20px;
    .nav-box {
      height: 54px;
      line-height: 54px;
      border-bottom: 1px solid #f0f0f0;
      padding-left: 27px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .go-back {
        font-size: 14px;
        color: #999999;
        vertical-align: middle;
        cursor: pointer;
        height: 54px;
        flex-shrink: 0;
        &:hover {
          color: #fe4d45;
        }
      }
      .question_icon {
        width: 14px;
        height: 14px;
        color: #ccc;
        display: inline-block;
        line-height: 12px;
        text-align: center;
        border-radius: 14px;
        border: 1px solid #ccc;
        font-size: 12px;
        font-weight: normal;
      }
      .question_icon:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
      }
      .division {
        display: inline-block;
        vertical-align: middle;
        margin: 0 20px;
        width: 1px;
        height: 20px;
        background: #cccccc;
      }
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #2e3458;
        vertical-align: middle;
        margin-right: 8px;
        height: 54px;
        flex-shrink: 0;
      }
    }
    .info-box {
      padding: 20px 28px;
      .roi-box-wrap {
        display: inline-block;
        vertical-align: middle;
      }
      .roi-box {
        display: flex;
        flex-direction: row;
        width: 300px;
        box-sizing: border-box;
        padding: 16px 14px;
        background-color: #fff6f6;
        border: 1px solid #fe8f8a;
        border-radius: 4px;
        .roi {
          background-color: #fe8f8a;
          color: #fff;
          font-size: 20px;
          font-weight: bold;
          width: 46px;
          height: 46px;
          border-radius: 6px;
          line-height: 46px;
          text-align: center;
          margin-right: 12px;
        }
        .roi-data {
          color: #333;
          font-size: 14px;
          padding-top: 2px;
          .value {
            color: #fe4d45;
            font-weight: bold;
            font-size: 20px;
            margin-top: 7px;
          }
          .update-btn {
            cursor: pointer;
            color: #7f85e9;
            margin-left: 45px;
            font-size: 14px;
          }
        }
      }
      .task-content {
        font-size: 14px;
        line-height: 20px;
        color: #333;
        display: inline-block;
        vertical-align: middle;
        margin-left: 34px;
        div {
          margin-bottom: 6px;
        }
        .send-status {
          color: #000;
          margin-right: 60px;
        }
        .num {
          color: #fe4d45;
        }
      }
    }
  }
  .effect-data {
    padding: 24px 28px;

    .isAutoMarketingOfficial2 {
      @media screen and (max-width: 1480px) {
        height: 16px;
        display: block;
      }

      @media screen and (min-width: 1481px) {
        height: 16px;
        display: none;
      }
    }

    .isAutoMarketingOfficial3 {
      @media screen and (max-width: 1480px) {
        padding-left: 0;
      }

      @media screen and (min-width: 1481px) {
        padding-left: 56px;
      }
    }

    .tab-line {
      border-bottom: 1px solid #ddd;
      margin-top: 20px;
      margin-bottom: 32px;
      .tab-item {
        display: inline-block;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #666;
        font-weight: bold;
        width: 106px;
        border-radius: 2px 2px 0 0;
        background-color: #fafafa;
        border-top: 1px solid #dddddd;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        margin-right: 2px;
        cursor: pointer;
        &.active {
          color: #fe4d45;
          background: #fff;
          border-top: 2px solid #fe4d45;
          position: relative;
          &::after {
            position: absolute;
            content: "";
            width: 100%;
            height: 5px;
            background: #fff;
            left: 0;
            bottom: -2px;
          }
        }
      }
    }
    .effect-content {
      .effect-item {
        display: inline-block;
        vertical-align: text-top;
        width: 250px;
        border: 1px solid #eee;
        margin-right: 19px;
        margin-bottom: 20px;
        .title {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          background: #fafafa;
          text-align: center;
          line-height: 50px;
        }
        .content {
          height: 233px;
          box-sizing: border-box;
          padding: 16px 19px;
          font-size: 14px;
          color: #333;
          line-height: 25px;
        }
      }
    }
    .trend-analysis {
      font-size: 14px;
      color: #333;
      font-weight: 500;
      margin-top: 32px;
      margin-bottom: 10px;
      .trend-wrap {
        margin-top: 23px;
        border: 1px solid #eee;
      }
      .trend-box-x {
        border-radius: 4px 4px 0 0;
        background: #fafafa;
        font-size: 14px;
        color: #333;
        padding: 32px 40px;
        .trend-item {
          margin-bottom: 16px;
          &:last-child {
            margin-bottom: 0;
          }
          .type-title {
            font-weight: bold;
            display: inline-block;
            width: 80px;
            vertical-align: text-top;
          }
          .trend-radio {
            display: inline-block;
            width: calc(100% - 80px);
            vertical-align: text-top;
            /deep/.el-radio__label {
              font-size: 14px;
            }
            /deep/.el-radio {
              margin-bottom: 5px;
            }
          }
        }
      }

      .trend-box {
        background: #fff;
        // margin-top: 17px;
        // border: 1px solid #eee;
        // border-top: none;
        border-radius: 0 0 4px 4px;
        padding: 44px 45px;
        .trend-tab {
          background: #eeeeee;
          display: inline-block;
          padding: 5px;
          .trend-item {
            cursor: pointer;
            width: 96px;
            height: 28px;
            line-height: 28px;
            font-size: 14px;
            color: #666;
            display: inline-block;
            text-align: center;
            &.active {
              background: #fff;
              color: #fe4d45;
            }
          }
        }
      }
    }
    .good-analysis {
      .title-line {
        font-size: 14px;
        color: #333;
        margin-bottom: 25px;
      }
      .goods-item {
        width: 100%;
        margin-right: 20px;
        margin-bottom: 20px;
        vertical-align: text-top;
        // @media screen and (max-width: 1400px) {
        //   width: 440px;
        // }
        &:nth-child(4) {
          margin-right: 0;
        }
        display: inline-block;
        .goods-title {
          margin-bottom: 9px;
          color: #333;
        }
        .goods-box {
          & > div {
            display: inline-block;
            margin-left: 8px;
          }
          img {
            width: 38px;
            height: 38px;
          }
          .shop-title {
            font-size: 14px;
            color: #666;
            width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .sku-line {
            color: #000;
            font-size: 14px;
            width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
.title-line {
  border-left: 3px solid #fe4d45;
  padding-left: 8px;
  line-height: 20px;
}
.tip-box {
  display: inline-block;
  padding-left: 12px;
  padding-right: 12px;
  text-align: left;
  // line-height: 21px;
  font-size: 14px;
  // margin-top: 12px;
  color: #999999;
  background: #fffaee;
  // position: relative;
  // margin: 20px 0 16px 0;
  border-radius: 28px;
  line-height: 28px;
  height: 28px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  // span{
  // white-space: nowrap;
  // text-overflow: ellipsis;
  // overflow: hidden;
  // }
  .warning-icon {
    color: #ffb95e;
    font-size: 14px;
    // position: absolute;
    left: 5px;
    top: 7px;
  }
}
.box-shadow {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}
.question_icon {
  width: 12px;
  height: 12px;
  color: #ccc;
  display: inline-block;
  line-height: 10px;
  text-align: center;
  border-radius: 12px;
  border: 1px solid #ccc;
  font-size: 10px;
  font-weight: normal;
}
.question_icon:hover {
  color: #fe4d45;
  border: 1px solid #fe4d45;
}
.price-input {
  display: inline-block;
  width: 140px;
  margin-top: 5px;
  // margin: 0 20px;
}
/deep/.el-input--suffix .el-input__inner {
  padding-right: 24px !important;
  overflow: hidden; /* 控制内容溢出时如何处理 */
  white-space: nowrap; /* 不换行 */
  text-overflow: ellipsis; /* 使用省略号表示被裁切的文本 */
}
</style>
